/**
 * What an SVG uses that vector images can't draw (see the runtime's svg.ts),
 * found from its text without a DOM, so the validator and the editor's
 * Problems can say so before the picture is in the game.
 */

const CHECKS: [RegExp, string][] = [
  [/<(?:\w+:)?text[\s>]/, 'text (convert it to outlines)'],
  [/<(?:\w+:)?image[\s>]/, 'embedded images'],
  [/<(?:\w+:)?foreignObject[\s>]/, 'foreignObject'],
  [/<(?:\w+:)?pattern[\s>]/, 'patterns'],
  [/<(?:\w+:)?filter[\s>]|\sfilter\s*=\s*["']url|filter\s*:\s*url/, 'filters (blur, shadows)'],
  [/<(?:\w+:)?mask[\s>]|\smask\s*=\s*["']url|mask\s*:\s*url/, 'masks'],
  [/<(?:\w+:)?clipPath[\s>]|clip-path\s*[=:]\s*["']?url/, 'clip paths'],
  [/<(?:\w+:)?(?:linear|radial)Gradient[\s>]/, 'gradients (each draws as one flat colour)'],
];

/** The features an SVG's text uses that a vector image leaves out or flattens, once each. */
export function svgProblems(text: string): string[] {
  if (!/<svg[\s>]/.test(text)) return ['the file is not an SVG'];
  const body = text.replace(/<!--[\s\S]*?-->/g, '');
  return CHECKS.filter(([re]) => re.test(body)).map(([, what]) => what);
}
